import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  volFilter: [
    {
      num: 0,
      departPlace: 'NEW YORK (NYC, US)',
      departCode: 'NYC',
      arriveCode: 'BCN',
      arrivePlace: 'BARCELONA (BCN, ES)',
      dateDepart: [],
      dateArrive: [],
      origin: 'NEW YORK',
      destination: 'BARCELONA',
      escale: false,
    }
  ],
  multiDest: -1, 
  volClass:'Economy',
  volReturn: true,
};

export const VolSearchBarSlice = createSlice({
  name: "VolSearchBar",
  initialState,
  reducers: {
    barFilter: (state, action) => {
      let num = action.payload.num;
      state.volFilter[num] = action.payload;
    },
    volType: (state, action) => {
      state.volReturn = action.payload;
    },
    volClass: (state, action) => {
      state.volClass = action.payload;
    },
    multiDest: (state, action) => {
      state.multiDest = action.payload;
    },
    addMultiDest: (state, action) => {
      state.multiDest = state.multiDest + 1;
    },
    removeMultiDest: (state, action) => {
      state.multiDest = state.multiDest - 1;
    },
  },
});
export const { barFilter, volType, volClass, addMultiDest,removeMultiDest ,multiDest} =
  VolSearchBarSlice.actions;

export default VolSearchBarSlice.reducer;
